module.exports = __webpack_public_path__ + "img/1-3.9263df2.svg";